<template>
    <div class="institution">
        <header>
            <p class="title">{{getInfo.orgName}}<span v-if="getInfo.isActive==1">已认证</span></p>
            <div class="info">
                <span>执业时间：{{getInfo.practicingTime}}年</span>
                <span>服务人数：{{getInfo.servePeople}}</span>
                <span>服务时长：{{getInfo.serveTime}}h</span>
                <span>地址：{{getInfo.address}}</span>
            </div>
            <p class="introduce">
                <el-image style="width: 18px; height:18px;margin-right:5px;" fit="scale-down" :src="require('@/assets/img/fuwu_icon.png')"></el-image>
                服务宗旨：{{getInfo.remark}}
            </p>
        </header>
        <main class="MainContent">
            <div class="left">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="概况信息" name="overview">
                        <p class="aptitudeName">概况信息</p>
                        <el-descriptions class="margin-top" :column="2" size="medium" border>
                            <el-descriptions-item>
                                <template slot="label">
                                    机构名称
                                </template>
                                {{getInfo.orgName}}
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    负责人
                                </template>
                                {{getInfo.corporateName}}
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    机构人数
                                </template>
                                {{getInfo.registerNumber}}人
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    联系电话
                                </template>
                                {{getInfo.contactTel}}
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    地址
                                </template>
                                {{getInfo.address}}
                            </el-descriptions-item>
                        </el-descriptions>
                        <p class="aptitudeName" style="padding-top: 20px;">资质信息</p>
                        <div class="certificate">
                            <el-image class="certificateimg" :src="item" v-for="item in getInfo.qualifications"></el-image>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="APP主页背景" name="APPHomeBG">
                        <p class="aptitudeName">背景图片</p>
                        <el-upload
                        class="avatar-uploader"
                        accept=".png,.jpg"
                        :action="actionUrl"
                        :headers="{Authorization:Authorization}"
                        :show-file-list="false"
                        v-loading="loading"
                        name="images"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">    
                        <img v-if="getInfo.orgLogo" :src="getInfo.orgLogo" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="right">
                <div class="title">
                    <span>预约来访</span>
                    <el-button type="primary" @click="$router.push('/digitalize/Appointmentallocation?organizationId='+organizationId)">查看全部</el-button>
                </div>
                <div class="comevisitNum">
                    <span>待分配：{{ OrgPreview.undoCount}}</span>
                    <span>已分配：{{ OrgPreview.doCount}}</span>
                    <span>累计接待：{{OrgPreview.totalCount}}</span>
                </div>
                <div class="item" v-for="item in OrgPreview.list" :key="item.appointmentOrgKey">
                    <p class="Name">
                        <label>{{item.realName}}</label>
                        <span>{{item.createdDate}}</span>
                    </p>
                    <div class="content">
                        <div>咨询主题：<span>{{ item.consultTheme }}</span></div>
                        <div>咨询方式：<span>{{item.consultType}}</span></div>  
                    </div>
                </div>

            </div>
        </main>
    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:false,
            actionUrl:process.env.VUE_APP_URL+'AppUser/UpdatePortraitAndCertificate',
            Authorization:sessionStorage.getItem('Authorization'),
            activeName:'overview',
            getInfo:{},
            organizationId:this.$route.query.organizationId,
            OrgPreview:'',
            OrgCode:JSON.parse(sessionStorage.getItem('xinxi')).OrgCode
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init(){
            let OrgCode=this.organizationId?this.organizationId:this.OrgCode;
            this.$Http_Post('/ConsultAppoint/GetOrgInfo/',{OrgCode:OrgCode}).then(res=>{
                if(res.Code==0){
                    this.getInfo=res.Data;
                    this.GetAppointmentOrgPreview();
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        // 预约来访
        GetAppointmentOrgPreview(){
            let OrgCode=this.organizationId?this.organizationId:this.OrgCode;
            this.$Http_Post('/ConsultSubscribe/GetAppointmentOrgPreview',{OrgCode:OrgCode}).then(res=>{
                if(res.Code==0){
                    this.OrgPreview=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        handleAvatarSuccess(file){
            this.loading=false;
            this.getInfo.orgLogo=file.Data;

        },
        beforeAvatarUpload(file){
            if(file.type=='image/jpeg' || file.type=='image/png'){
                this.loading=true;
            }else{
                this.$message.warning("请上传jpg或者png格式图片");
                return false;
            }
        }
    },
}
</script>
<style scoped>
.institution header{background: #fff;padding: 20px;}
.institution header .title{font-size: 18px;}
.institution header .title span{background: #17C26F;color: #fff;border-radius: 200px;padding: 2px 10px;font-size: 12px;margin-left: 10px;}
.institution header .info{margin: 20px 0;}
.institution header .info span{font-size: 14px;color: #666666;border-right: 1px solid #CCCCCC;padding-right: 20px;margin-right: 20px;}
.institution header .info span:last-child{border:none;margin: 0;padding: 0;}
.institution header .introduce{font-size: 14px;display: flex;}
.institution .MainContent{display: flex;margin-top: 16px;}
.institution .MainContent .left{flex: auto;background: #fff;padding: 16px;}
.institution .MainContent .left .aptitudeName{font-size: 16px;padding: 0 0 12px;}
.institution .MainContent .left .certificate .certificateimg{width: 200px;min-height: 200px;}

.institution .MainContent .left .avatar-uploader{display: inline-block;border: 1px dashed #d9d9d9;}
.institution .MainContent .left .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 178px;height: 178px;line-height: 178px;text-align: center;}
.institution .MainContent .left .avatar {width: 178px;height: 178px;display: block;  }
.institution .MainContent .right{background: #fff;margin-left: 16px;padding: 16px 16px 50px;flex: none;width: 382px;}
.institution .MainContent .right .title{font-size: 16px;color: #000;display: flex;justify-content: space-between;align-items: center;}
.institution .MainContent .right .comevisitNum{padding: 15px 0;}
.institution .MainContent .right .comevisitNum span{font-size: 14px;color: #565656;margin-right: 60px;}
.institution .MainContent .right .comevisitNum span:last-child{margin: 0;}
.institution .MainContent .right .item{background: #F7F7F7;padding: 15px 20px;margin-top: 5px;}
.institution .MainContent .right .item .Name{font-size: 14px;color: #3D3D3D;padding-bottom: 8px;display: flex;justify-content: space-between;align-items: center;}
.institution .MainContent .right .item .Name label{font-size: 16px;color: #000;}
.institution .MainContent .right .item .content div{font-size: 14px;color: #666666;display: inline-block;margin-right: 40px;}
.institution .MainContent .right .item .content div:last-child{margin: 0;}
.institution .MainContent .right .item .content div span{font-size: 14px;color: #333333;}

</style>